import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="bg-navy text-cream pt-32 pb-20 px-5 min-h-screen flex flex-col items-center justify-center text-center relative overflow-hidden" data-id="element-68">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-69"></div>

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="max-w-4xl mx-auto flex flex-col items-center relative z-10" data-id="element-70">
        <span className="inline-block border border-gold text-gold px-4 py-1.5 text-xs font-bold tracking-[0.2em] uppercase mb-8 rounded-full font-dmsans" data-id="element-71">
          EBOOK · COMUNICACIÓN COMERCIAL EN TURISMO
        </span>

        <h1 className="font-playfair text-4xl md:text-6xl lg:text-7xl font-bold leading-[1.1] mb-6 text-cream" data-id="element-72">
          ¿Mandás cotizaciones y el cliente{' '}
          <span className="text-gold italic font-normal" data-id="element-73">desaparece</span>?
        </h1>

        <p className="font-dmsans text-lg md:text-xl text-cream/80 mb-6 max-w-2xl leading-relaxed" data-id="element-74">
          Un método práctico para presentar propuestas de viaje con estructura y{' '}
          <span className="text-gold font-medium" data-id="element-75">valor</span> — por WhatsApp,
          email y llamadas.
        </p>

        <p className="font-dmsans text-sm md:text-base text-gold/80 mb-12 max-w-xl uppercase tracking-wider font-medium" data-id="element-76">
          Cada cotización sin estructura es una venta que no cierra.
        </p>

        <div className="w-full max-w-lg mx-auto mb-12 relative" data-id="element-77">
          <div className="absolute inset-0 bg-gold/20 blur-[60px] rounded-full" data-id="element-78"></div>
          <img src="https://cdn.magicpatterns.com/uploads/7UfTeQJhri4ujhzd1D84PF/mock_up_3.png" alt="Ebook Comunicación Comercial en Turismo" className="relative z-10 w-full h-auto drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)]" data-id="element-79" />
        </div>

        <a href="#oferta" className="w-full md:w-auto bg-gold text-navy font-dmsans font-bold text-lg py-5 px-10 rounded hover:bg-cream hover:scale-[1.02] transition-all duration-300 shadow-[0_0_30px_rgba(201,168,76,0.2)]" data-id="element-80">
          Quiero el E-book
        </a>
      </motion.div>
    </section>;
}